import Vue from 'vue';

class TagsService {
  getTicketTags() {
    if (Vue.prototype.$store.ticketTags) {
      return Vue.prototype.$store.ticketTags
        .filter((tag) => tag.visible)
        .map(tag => {
          return {
            id: tag.id,
            title: tag.name,
            value: tag.id,
            checked: !!Vue.prototype.$store.currentTicketTags.find(currentTag => currentTag.id === tag.id)
          }
        });
    }

    return []
  }
}

export default TagsService;
